export const orderHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },
  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "쿠폰번호",
    value: "couponNo",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "지사",
    value: "branchName",
    sortable: false
  },
  {
    text: "기사명",
    value: "engineerName",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "유형",
    value: "workTypeName",
    sortable: false
  },
  {
    text: "장착비",
    value: "basicPayment",
    sortable: false
  },
  {
    text: "추가비",
    value: "optionPayment",
    sortable: false
  },
  {
    text: "탈거비",
    value: "removalPayment",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "해피콜",
    value: "happycall",
    sortable: false
  },
  {
    text: "문자",
    value: "sms",
    sortable: false
  },
  {
    text: "설치확인서",
    value: "installConfirm",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
]
export const happycallHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "해피콜요청일자",
    value: "hcCreatedDateTime",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },
  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "지사",
    value: "branchName",
    sortable: false
  },
  {
    text: "기사명",
    value: "engineerName",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "유형",
    value: "workTypeName",
    sortable: false
  },
  {
    text: "장착비",
    value: "basicPayment",
    sortable: false
  },
  {
    text: "추가비",
    value: "optionPayment",
    sortable: false
  },
  {
    text: "탈거비",
    value: "removalPayment",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "해피콜",
    value: "happycall",
    sortable: false
  },
  {
    text: "문자",
    value: "sms",
    sortable: false
  },
  {
    text: "설치확인서",
    value: "installConfirm",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
]

export const asHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },

  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "지사",
    value: "branchName",
    sortable: false
  },
  {
    text: "기사명",
    value: "engineerName",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "유형",
    value: "workTypeName",
    sortable: false
  },
  {
    text: "결제구분",
    value: "basicPayment",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "해피콜",
    value: "happycall",
    sortable: false
  },
  {
    text: "문자",
    value: "sms",
    sortable: false
  },
  {
    text: "작동여부",
    value: "installConfirm",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
]

export const claimHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },

  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "지사",
    value: "branchName",
    sortable: false
  },
  {
    text: "기사명",
    value: "engineerName",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "접수형태",
    value: "claimInbound",
    sortable: false
  },
  {
    text: "진행상황",
    value: "statName",
    sortable: false
  },
  {
    text: "클레임분류",
    value: "claimType",
    sortable: false
  },
  {
    text: "처리결과",
    value: "result",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
]

export const productHeader = [
  {
    text: "업체",
    value: "providerName",
    sortable: true
  },

  {
    text: "상품분류",
    value: "categoryName",
    sortable: true
  },
  {
    text: "상품명",
    value: "name",
    sortable: true
  },
  {
    text: "구분",
    value: "typeName",
    sortable: true
  },
  {
    text: "업체단가",
    value: "providerPrice",
    sortable: true
  },
  {
    text: "지점단가",
    value: "sellerPrice",
    sortable: true
  },
  {
    text: "상세정보",
    value: "id",
    sortable: true
  },
]

export const companyHeader = [
  {
    text: "아이디",
    value: "loginId",
    sortable: true
  },
  {
    text: "업체명",
    value: "name",
    sortable: true
  },

  {
    text: "담당자이름",
    value: "pocName",
    sortable: true
  },
  {
    text: "휴대폰번호",
    value: "phoneNo",
    sortable: true
  },
  {
    text: "상태",
    value: "activeYn",
    sortable: true
  },
  {
    text: "상세정보",
    value: "id",
    sortable: true
  },
]

export const branchHeader = [
  {
    text: "그룹",
    value: "groupName",
    sortable: true
  },
  {
    text: "아이디",
    value: "loginId",
    sortable: true
  },
  {
    text: "지점명",
    value: "name",
    sortable: true
  },

  {
    text: "대표자이름",
    value: "representative",
    sortable: true
  },
  {
    text: "연락처",
    value: "phoneNo",
    sortable: true
  },
  {
    text: "등록일",
    value: "createdAt",
    sortable: true
  },
  {
    text: "상세정보",
    value: "id",
    sortable: true
  },

]

export const engineerHeader = [
  {
    text: "그룹",
    value: "branchName",
    sortable: true
  },
  {
    text: "아이디",
    value: "loginId",
    sortable: true
  },
  {
    text: "이름",
    value: "name",
    sortable: true
  },
  {
    text: "휴대폰번호",
    value: "phoneNo",
    sortable: true
  },
  {
    text: "주소",
    value: "address",
    sortable: true
  },
  {
    text: "메모",
    value: "memo",
    sortable: true
  },
  {
    text: "상태",
    value: "activeYn",
    sortable: true
  },
  {
    text: "상세정보",
    value: "id",
    sortable: true
  },
]

export const adminHeader = [
  {
    text: "아이디",
    value: "userId",
    sortable: true
  },
  {
    text: "이름",
    value: "name",
    sortable: true
  },
  {
    text: "휴대폰번호",
    value: "phoneNo",
    sortable: true
  },
  {
    text: "등록날짜",
    value: "createdAt",
    sortable: true
  },
  {
    text: "상세정보",
    value: "id",
    sortable: true
  },
]

export const settlementHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "완료날짜",
    value: "finishDate",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },
  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "쿠폰번호",
    value: "couponNo",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "지사",
    value: "branchName",
    sortable: false
  },
  {
    text: "기사명",
    value: "engineerName",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "주문유형",
    value: "orderType",
    sortable: false
  },
  {
    text: "유형",
    value: "workTypeName",
    sortable: false
  },
  {
    text: "장착비",
    value: "basicPayment",
    sortable: false
  },
  {
    text: "추가비",
    value: "optionPayment",
    sortable: false
  },
  {
    text: "탈거비",
    value: "removalPayment",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "정산",
    value: "settlement",
    sortable: false
  },
  {
    text: "정산완료일",
    value: "settleComplete",
    sortable: false
  },
  {
    text: "설치확인서",
    value: "installConfirm",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
]
export const cardListHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "완료날짜",
    value: "finishDate",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },
  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "내용",
    value: "desc",
    sortable: false
  },
  {
    text: "금액",
    value: "amount",
    sortable: false
  },
  {
    text: "카드사명",
    value: "cardCompany",
    sortable: false
  },
  {
    text: "카드번호",
    value: "cardNo",
    sortable: false
  },
  {
    text: "유효기간",
    value: "cardValidPeriod",
    sortable: false
  },
  {
    text: "승인번호",
    value: "txApprovalNo",
    sortable: false
  },
  {
    text: "승인일자",
    value: "approvalDateTime",
    sortable: false
  },
  {
    text: "비고",
    value: "remark",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
  {
    text: "입력",
    value: "input",
    sortable: false
  },
]
export const taxListHeader = [
  {
    text: "접수날짜",
    value: "daterPlaced",
    sortable: false
  },
  {
    text: "완료날짜",
    value: "finishDate",
    sortable: false
  },
  {
    text: "업체명",
    value: "providerName",
    sortable: false
  },
  {
    text: "상품명",
    value: "productName",
    sortable: false
  },
  {
    text: "고객명",
    value: "customer",
    sortable: false
  },
  {
    text: "연락처",
    value: "customerPhone",
    sortable: false
  },
  {
    text: "주소",
    value: "customerAddr",
    sortable: false
  },
  {
    text: "진행상황",
    value: "progress",
    sortable: false
  },
  {
    text: "내용",
    value: "desc",
    sortable: false
  },
  {
    text: "금액",
    value: "amount",
    sortable: false
  },
  {
    text: "계산서발행일자",
    value: "approvalDateTime",
    sortable: false
  },
  {
    text: "비고",
    value: "remark",
    sortable: false
  },
  {
    text: "상세정보",
    value: "detailed",
    sortable: false
  },
  {
    text: "입력",
    value: "input",
    sortable: false
  },
]